/**
 * iWoBroadcastTvManuscriptModule 广电广电文稿-编辑页
 * description:  广电广电文稿-编辑页
 * author: Qian.qianchen 2019-04-01
 */
'use strict';
angular.module('iWoBroadcastTvManuscriptModule', []).controller('iWoBroadcastTvManuscriptCtrl', [
    '$scope',
    'initeditctrBtnsService',
    'trsHttpService',
    '$q',
    'initiWoDataService',
    '$stateParams',
    '$compile',
    '$element',
    '$timeout',
    'beforeonload',
    '$state',
    'ueditorService',
    'editIsLock',
    'jsonArrayToStringService',
    '$validation',
    'editingCenterService',
    'modalDialog',
    '$modal',
    'myManuscriptService',
    'storageListenerService',
    '$window',
    'trsspliceString',
    '$sessionStorage',
    'newMediaService',
    'iWoService',
    'publicToolService',
    function(
        $scope,
        initeditctrBtnsService,
        trsHttpService,
        $q,
        initiWoDataService,
        $stateParams,
        $compile,
        $element,
        $timeout,
        beforeonload,
        $state,
        ueditorService,
        editIsLock,
        jsonArrayToStringService,
        $validation,
        editingCenterService,
        modalDialog,
        $modal,
        myManuscriptService,
        storageListenerService,
        $window,
        trsspliceString,
        $sessionStorage,
        newMediaService,
        iWoService,
        publicToolService
    ) {
        $scope = iWoService.addFuture($scope, ['sendmessage']);
        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                showVideoAudioDiv: false, // 初始化音视频所需的div
                switch: 'manuscriptInfo', // 默认选中稿件信息
                manuscriptFormError: [],
                isHaveExtend: false, // 是否含有扩展信息
                articleSelectorShow: false,
                leadSelectorShow: false,
                compileSelectorShow: false,
                totalSelectorShow: false,
                isFromPlannedOrder: JSON.parse($stateParams.isfromplannedorder),
                infullscreen: false,
                support: {
                    content: '', // 提交给辅助写作的纯文本
                },
                isFusionEditor: $state.current.name == 'fusionmanuscript', // 是否来自融合编辑器
                manuscriptDocSaveMethod: ['savePersonalWenGaoDoc', 'saveReceivedWenGaoDoc'],
                zhengwen: false,
                columnItems: [{ name: '请先选择产品' }],
                btnRights: {},
                sourceid: $stateParams.sourceid,
                serviceid: {
                    '15': 'mlf_tv',
                    '16': 'mlf_broadcast',
                },
                fusionServiceid: {
                    '15': 'mlf_fusiontv',
                    '16': 'mlf_fusionbroadcast',
                },
            };
            $scope.data = {
                speed: 264,
                userName: '',
                currReporter: '',
                currBroadcast: '',
                currEditor: '',
                reporterArr: [], // 记者标签数组
                broadcastArr: [], // 播音标签数组
                compileArr: [], // 编辑标签数组
                lastVersionid: '',
                METADATAID: angular.isDefined($stateParams.iwometadataid) ? $stateParams.iwometadataid : '0',
                CHNLDOCID: angular.isDefined($stateParams.iwochnldocid) ? $stateParams.iwochnldocid : '0',
                copyVersion: [],
                channelList: [],
                trench: $scope.status.sourceid == 15 ? '电视' : '广播',
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            initBtnRights();
            emitCloseWindow();
            addReporterArr();
            $scope.editFlag = {
                media: 'iwo', 
                docType: 'manuscript',
            };
        }

        /**
         * [emitCloseWindow description]页面初始化时添加本地用户
         * @return {[type]} [description]
         */
        function addReporterArr() {
            // if (window.localStorage.getItem('ls.curUserInfo') ){ // session改变
            if ($sessionStorage.get('curUserInfo')) {
                // var currAuthorInfo = JSON.parse(window.localStorage.getItem('ls.curUserInfo')) // session改变
                var currAuthorInfo = $sessionStorage.get('curUserInfo');
                currAuthorInfo.USERNAME = currAuthorInfo.TRUENAME;
                currAuthorInfo.TYPE = '23';
                $scope.data.reporterArr.push(currAuthorInfo);
            } else {
                $timeout(() => {
                    addReporterArr();
                }, 1000);
            }
        }

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            editingCenterService.allAppCloseWindow($scope, {typeName: 'iwo', saveLocal: false});
        }

        /**
         * [initBtnRights description] 初始化按钮权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            var methodnameArray = ['iwo.personal', 'iwo.received'];
            initeditctrBtnsService.initIwoData(methodnameArray[$stateParams.iwoplatform]).then(function(data) {
                data.forEach((item, index) => {
                    $scope.status.btnRights[item.OPERNAME.split('.')[2]] = true;
                });
            });
            publicToolService.getModeconfiguration('IM').then((config) => {
                $scope.status.IM = config;
            });
        }

        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            if (!$scope.status.isFusionEditor) {
                ($stateParams.iwometadataid
                    ? initEditData().then(function() {
                        initBroadcastEditData();
                    })
                    : initNewData()
                ).then(function() {
                    if ($scope.status.isFromPlannedOrder) {
                        getPlannedOrderData();
                    }
                    beforeonload.beforeonloadAlert($scope);
                });
            }
        }

        /**
         * [initNewData description] 新数据初始化
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        function initNewData(dealWithListFun) {
            var defer = $q.defer();
            $scope.list = initiWoDataService.initManuscript();
            $scope.broadcastList = $scope.list;
            initExtendAttr();
            getSpeed()
                .then(function() {
                    return loadDirective();
                })
                .then(function() {
                    defer.resolve();
                });
            // 融合编辑器下处理list
            if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                dealWithListFun();
            }

            return defer.promise;
        }

        /**
         * [initEditData description] 数据编辑初始化
         * @return {[type]} [description]
         */
        function initEditData() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusiontv',
                methodname: 'getVirtualWenGaoDoc',
                SourceDocId: $stateParams.iwometadataid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.list = data;
                document.title = data.TITLE;
                $scope.data.reporterArr = data.FGD_AUTHINFO;
                $scope.data.compileArr = data.FGD_EDITINFO;
                $scope.data.speed = data.SPEECHRATE.split('字/分钟')[0];
                if (data.EXATTRIBUTE.length > 0) {
                    $scope.status.isHaveExtend = true;
                } else {
                    $scope.status.isHaveExtend = false;
                }
                if ($scope.list.EXATTRIBUTE instanceof Array) {
                    $scope.list.EXATTRIBUTE.map(function(item) {
                        item.enumArr =
                            item.formType == 'input'
                                ? ''
                                : item.enumValue == ''
                                    ? []
                                    : item.enumValue.split(',').map(function(item) {
                                        return { name: item };
                                    });
                        item.value = item.formType == 'input' ? item.value : { name: item.value };
                    });
                } else {
                    $scope.list.EXATTRIBUTE = [];
                }
                $scope.data.EXATTRIBUTE = angular.copy($scope.list.EXATTRIBUTE);
                $scope.data.broadcastArr = data.BROADCASTING;
                $scope.broadcastList = angular.copy($scope.list); // 复制一份用作广播广电文稿
                getVersion()
                    .then(function() {
                        loadDirective();
                    })
                    .then(function() {
                        defer.resolve();
                    });
                editIsLock.lockDraft($stateParams.iwometadataid);
            });
            return defer.promise;
        }

        /**
         * [initBroadcastEditData 数据编辑，初始化广播广电文稿数据]
         * @return {[type]} [description]
         */
        function initBroadcastEditData() {
            var params = {
                serviceid: 'mlf_fusionbroadcast',
                methodname: 'getVirtualWenGaoDoc',
                SourceDocId: $stateParams.iwometadataid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.broadcastList.METADATAID = data.METADATAID;
            });
        }

        /**
         * [initExtendAttr description] 获取扩展属性
         * @return {[type]} [description]
         */
        function initExtendAttr() {
            var params = {
                serviceid: 'mlf_docexattribute',
                methodname: 'querryDocAttr',
                attrStatus: 1,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.list.EXATTRIBUTE = data.map(function(item, index) {
                    return {
                        id: item.DOCEXATTRIBUTEID,
                        name: item.ATTRNAME,
                        desc: item.ATTRDESC,
                        formType: item.FORMTYPE,
                        length: item.ATTRLENGTH,
                        enumValue: item.ENUMVALUE,
                        displayOrder: item.DISPLAYORDER,
                        value: '',
                        enumArr:
                            item.FORMTYPE == 'input'
                                ? ''
                                : item.ENUMVALUE.split(',').map(function(item) {
                                    return { name: item };
                                }),
                    };
                });
                $scope.data.EXATTRIBUTE = angular.copy($scope.list.EXATTRIBUTE);
                if (data.length > 0) {
                    $scope.status.isHaveExtend = true;
                } else {
                    $scope.status.isHaveExtend = false;
                }
            });
        }

        /**
         * [getPlannedOrderData description] 获取关联的串联单信息
         * @return {[type]} [description]
         */
        function getPlannedOrderData() {
            var defer = $q.defer();
            var params;
            if ($stateParams.trench == 'iwo') {
                params = {
                    serviceid: $scope.status.fusionServiceid[$scope.status.sourceid],
                    methodname: 'getVirtualChuanLianDoc',
                    SourceDocId: $stateParams.seriesdocid,
                };
            } else {
                params = {
                    serviceid: $scope.status.serviceid[$scope.status.sourceid],
                    methodname: 'getWenGaoDoc',
                    MetaDataId: $stateParams.seriesdocid,
                };
            }

            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.plannedOrderData = data;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getSpeed description] 新建时获取语速
         * @return {[type]} [description]
         */
        function getSpeed() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_tenant',
                methodname: 'getTenantAttributes',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.speed = angular.isDefined(JSON.parse(data.DETAIL).SPEECHRATE) ? JSON.parse(data.DETAIL).SPEECHRATE : 264;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [getObjFromArr description] 根据属性查询数组中的对象
         * @param  {[type]} arr      [description] 数组
         * @param  {[type]} property [description] 属性名
         * @param  {[type]} value    [description] 属性只
         * @return {[type]}          [description]
         */
        function getObjFromArr(arr, property, value) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i][property] == value) {
                    return arr[i];
                }
            }
            return -1;
        }


        /**
         * [loadDirective description] 动态加载编辑器指令
         * @return {[type]} [description]
         */
        function loadDirective() {
            var defer = $q.defer();
            if ($stateParams.issave === undefined || $stateParams.issave === '0') {
                // 用于融合编辑器的虚拟表单校验，虚拟表单检验不需要加载编辑器
                LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function() {
                    var ueditor =
                        '<ueditor-for-manuscript edit-flag="editFlag" form="manuscriptForm" has-content="status.hasContent" type="{{\'tv\'}}" versionid = "data.lastVersionid" list="list" infullscreen="status.infullscreen" speed="' +
                        $scope.data.speed +
                        '"></ueditor-for-manuscript>';
                    // $scope.button = { title: "政治常识校对", name: "polComSense" };
                    // var ueditor = '<ueditor  custom-button-fn="politicalCommonSense()" custom-button="button" form="manuscriptForm" versionid = "data.lastVersionid" list="list"></ueditor>';
                    ueditor = $compile(ueditor)($scope);
                    $element.find('ueditorLocation').append(ueditor);
                    $scope.status.support.content = $scope.list.CONTENT;
                    var ue = UE.getEditor('ueditor');
                    ue.ready(function() {
                        ue.addListener('keydown', function(type, event) {
                            if (event.keyCode === 13) {
                                // 获取纯文本
                                $scope.status.support.content = ue.getContentTxt();
                            }
                        });
                        defer.resolve();
                    });
                });
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        /**
         * [getVersion description]获取流程版本与操作日志
         * @return {[type]} [description]
         */
        function getVersion(id) {
            var deferred = $q.defer();
            var metadataid = angular.isDefined(id) ? id : $stateParams.iwometadataid;
            editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(
                function(data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    $scope.status.hasVersionTime = true;
                    $scope.data.lastVersionid = data.lastVersionid;
                    deferred.resolve();
                },
                function() {
                    deferred.resolve();
                }
            );
            return deferred.promise;
        }

        /**
         * [saveContent description] 保存内容
         * @return {[type]} [description]
         */
        function saveContent() {
            if (!$scope.status.isFusionEditor) {
                ueditorService.saveContent($scope.list);
            }
        }

        /**
         * [identificationFormat description] 标识符格式化
         * @param  {[type]} content [description]
         * @return {[type]}         [description]
         */
        function identificationFormat(content) {
            if (content.match(/【(.*?)】/g) == null) {
                return '';
            } else {
                var identificationArr = content.match(/【(.*?)】/g).map(function(item) {
                    return item.substring(1, item.length - 1);
                });
                var structureArr = [];
                for (var i = 0; i < identificationArr.length; i++) {
                    if (identificationArr[i] == '导语') {
                        structureArr.push('导');
                    } else if (identificationArr[i] == '正文') {
                        structureArr.push('正');
                    } else if (identificationArr[i] == '编后') {
                        structureArr.push('编');
                    }
                }
                return structureArr.join(',');
            }
        }

        /**
         * [listDataFormat description] 稿件信息格式化
         * @return {[type]} [description]
         */
        function listDataFormat(list) {
            $scope[list].CONTENTSTRUCTURE = identificationFormat($scope[list].CONTENT);
            $scope[list].SOURCEDOCID = $scope.data.METADATAID;
            $scope[list].SPEECHRATE = $scope.data.speed + '字/分钟';
            $scope[list].BROADCASTING = $scope.data.broadcastArr
                .map(function(item) {
                    return item.ID;
                })
                .join(',');
            $scope[list].BROADCASTINGNAME = trsspliceString.spliceString($scope.data.broadcastArr, 'USERNAME', ',');
            $scope[list].FGD_EDITINFO = $scope.data.compileArr;
            $scope[list].FGD_AUTHINFO = $scope.data.reporterArr;
        }

        /**
         * [saveBasicDoc description] 基础稿保存
         * @return {[type]} [description] 基础稿保存数据
         */
        function saveBasicDoc() {
            var list = {
                serviceid: 'mlf_myrelease',
                METHODNAME: $state.params.fromType ? 'saveDeptNews' : $scope.status.manuscriptDocSaveMethod[$stateParams.iwoplatform],
                OPERFLAG: identificationFormat($scope.list.CONTENT),
                METADATAID: $scope.data.METADATAID,
                TITLE: $scope.list.TITLE,
                DOCWORDSCOUNT: $scope.list.DOCWORDSCOUNT,
                CONTENT: $scope.list.CONTENT,
                HTMLCONTENT: $scope.list.HTMLCONTENT,
                DeptmentalDocId: $state.params.departmentaldocid,
                FGD_EDITINFO: $scope.data.compileArr,
                FGD_AUTHINFO: $scope.data.reporterArr,
                THEMEFLOWER: $scope.list.THEMEFLOWER,
                SUBTITLEWORDS: $scope.list.SUBTITLEWORDS,
                CORRESPONDENT: $scope.list.CORRESPONDENT
            };
            // JSON对象数组转字符串
            list = jsonArrayToStringService.jsonArrayToString(list);
            list.HTMLCONTENT = list.HTMLCONTENT.replace(
                /_ueditor_page_break_tag_/g,
                "<hr class='pagebreak' noshade='noshade' size='5' style='-webkit-user-select: none;'>"
            );
            return list;
        }

        /**
         * [disposeAttribute 格式化属性字段]
         * @return {[type]} [description]
         */
        function disposeAttribute() {
            $scope.list.EXATTRIBUTE = angular.copy($scope.data.EXATTRIBUTE);
            for (var i = 0; i < $scope.list.EXATTRIBUTE.length; i++) {
                var obj = $scope.list.EXATTRIBUTE[i];
                if (obj.formType == 'select') {
                    obj.enumValue = trsspliceString.spliceString(obj.enumArr, 'name', ',');
                    obj.value = obj.value ? obj.value.name : '';
                }
                delete obj.enumArr;
            }
        }

        /**
         * [saveTvDoc description] 电视广电文稿保存
         * @return {[type]} [description]
         */
        function saveTvDoc() {
            var defer = $q.defer();
            disposeAttribute();
            listDataFormat('list');
            var list = angular.copy($scope.list);
            if (!$stateParams.iwometadataid) {
                $scope.broadcastList = angular.copy(list);
            } // 如果是新建广电文稿的时候复制一份用于保存广播虚拟搞
            if ($scope.status.isFromPlannedOrder) {
                list.serviceid = 'mlf_tv';
                list.METHODNAME = 'saveWenGaoDocForYiQianEdit';
                list.seriesDocId = $scope.data.plannedOrderData.METADATAID;
                list.quoteChnlId = $scope.data.plannedOrderData.QUOTECHNLID;
                list.isBlankFlag = 1;
                list.siteId = $scope.data.plannedOrderData.WEBSITEID ? $scope.data.plannedOrderData.WEBSITEID : $stateParams.siteid;
                list.FGD_EDITINFO = $scope.data.compileArr;
                list.FGD_AUTHINFO = $scope.data.reporterArr;
            } else {
                list.serviceid = 'mlf_fusiontv';
                list.METHODNAME = 'saveVirtualWenGaoDoc';
            }
            list = jsonArrayToStringService.jsonArrayToString(list);
            list.HTMLCONTENT = list.HTMLCONTENT.replace(
                /_ueditor_page_break_tag_/g,
                "<hr class='pagebreak' noshade='noshade' size='5' style='-webkit-user-select: none;'>"
            );
            $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', list, 'post').then(function(result) {
                $scope.list.METADATAID = result.METADATAID;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [saveBroadcastDoc description] 广播广电文稿保存
         * @return {[type]} [description]
         */
        function saveBroadcastDoc() {
            var defer = $q.defer();
            // disposeAttribute();
            listDataFormat('broadcastList');
            var list = angular.copy($scope.list);
            list.METADATAID = $scope.broadcastList.METADATAID;
            if ($scope.status.isFromPlannedOrder) {
                list.serviceid = 'mlf_broadcast';
                list.METHODNAME = 'saveWenGaoDocForYiQianEdit';
                list.seriesDocId = $scope.data.plannedOrderData.METADATAID;
                list.quoteChnlId = $scope.data.plannedOrderData.QUOTECHNLID;
                list.isBlankFlag = 1;
                list.siteId = $scope.data.plannedOrderData.WEBSITEID ? $scope.data.plannedOrderData.WEBSITEID : $stateParams.siteid;
                list.FGD_EDITINFO = $scope.data.compileArr;
                list.FGD_AUTHINFO = $scope.data.reporterArr;
            } else {
                list.serviceid = 'mlf_fusionbroadcast';
                list.METHODNAME = 'saveVirtualWenGaoDoc';
            }
            list = jsonArrayToStringService.jsonArrayToString(list);
            list.HTMLCONTENT = list.HTMLCONTENT.replace(
                /_ueditor_page_break_tag_/g,
                "<hr class='pagebreak' noshade='noshade' size='5' style='-webkit-user-select: none;'>"
            );
            $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', list, 'post').then(function(result) {
                $scope.broadcastList.METADATAID = result.METADATAID;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [manageDataAfterSave description]保存操作完成后进行数据处理
         * @param  {[type]} data [description]保存后的返回值
         * @param  {[type]} flag [description]调用保存服务后是否弹出成功窗口判断
         * @return {[type]}      [description]
         */
        function manageDataAfterSave(data, flag) {
            $stateParams.iwochnldocid = $scope.data.CHNLDOCID;
            $stateParams.iwometadataid = $scope.data.METADATAID;
            // 为父窗口传递成功的稿件id编号
            if (window.opener && window.opener.vuexStore) {
                window.opener.vuexStore.newManuId = data.METADATAID;
            }
            $scope.data.incomeData = [
                {
                    TITLE: $scope.list.TITLE,
                    CHNLDOCID: $stateParams.iwochnldocid,
                    METADATAID: $stateParams.iwometadataid,
                    DOCTYPEID: 9,
                },
            ];
            if (flag) {
                if (!$scope.status.isFusionEditor) {
                    storageListenerService.addListenerToIwo('manuscriptSaved');
                    $state.transitionTo($state.current, $stateParams, {
                        reload: false,
                    });
                }
                if (!$scope.status.isFusionEditor) {
                    $timeout(function() {
                        modalDialog.alertType('保存成功', '', 'success');
                    }, 500);
                }
            } else {
                $scope.params = {};
            }
        }

        /**
         * [save description]稿件保存方法
         * @param  {[Boolean]} flag [description]标识
         * @return {[type]}      [description]
         */
        function save(flag) {
            var deferred = $q.defer();
            $scope.status.isedit = !!$stateParams.iwometadataid;
            saveContent();
            $timeout(function() {
                $scope.manuscriptForm.$pending = {};
                $validation
                    .validate($scope.manuscriptForm)
                    .success(function() {
                        modalDialog.isSecretInformation(
                            $stateParams.iwometadataid,
                            function() {
                                $scope.manuscriptForm.$setPristine();
                                $scope.status.openBtn = false;
                                if ($scope.status.isFromPlannedOrder) {
                                    if ($stateParams.sourceid == 15) {
                                        saveTvDoc().then(function() {
                                            modalDialog.alertType('保存成功', '', 'success', false, function() {
                                                beforeonload.refresh($scope);
                                                if ($stateParams.trench == 'iwo') {
                                                    storageListenerService.addListenerToIwo('newManuscriptSaved');
                                                } else if ($stateParams.trench == 'tv') {
                                                    storageListenerService.addListenerToTv('newManuscriptSaved');
                                                } else {
                                                    storageListenerService.addListenerToIwo('newManuscriptSaved');
                                                }
                                                deferred.resolve();
                                                var opened = $window.open('about:blank', '_self');
                                                opened.close();
                                            });
                                        });
                                    } else {
                                        saveBroadcastDoc().then(function() {
                                            modalDialog.alertType('保存成功', '', 'success', false, function() {
                                                beforeonload.refresh($scope);
                                                if ($stateParams.trench == 'iwo') {
                                                    storageListenerService.addListenerToIwo('newManuscriptSaved');
                                                } else if ($stateParams.trench == 'tv') {
                                                    storageListenerService.addListenerToTv('newManuscriptSaved');
                                                } else {
                                                    storageListenerService.addListenerToBroadcast('newManuscriptSaved');
                                                }
                                                deferred.resolve();
                                                var opened = $window.open('about:blank', '_self');
                                                opened.close();
                                            });
                                        });
                                    }
                                } else {
                                    var list = saveBasicDoc();
                                    $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', list, 'post').then(
                                        function(data) {
                                            $scope.data.METADATAID = data.METADATAID;
                                            $scope.data.CHNLDOCID = data.CHNLDOCID;
                                            if (!$scope.status.isedit) {
                                                $scope.status.isedit = false;
                                            } else {
                                                $scope.status.isedit = true;
                                            }
                                            saveTvDoc()
                                                .then(function() {
                                                    return saveBroadcastDoc();
                                                })
                                                .then(function() {
                                                    manageDataAfterSave(data, flag);
                                                    beforeonload.refresh($scope);
                                                    deferred.resolve(data);
                                                });
                                        },
                                        function(data) {
                                            deferred.reject(data);
                                        }
                                    );
                                }
                            },
                            function(data) {
                                // 有敏感词，并且点击确定修改敏感词
                                deferred.reject();
                            },
                            $scope.status.isFusionEditor
                        );
                    })
                    .error(function(msg) {
                        angular.invalidPosition($scope.manuscriptForm, $element);
                        deferred.reject();
                    });
            });
            return deferred.promise;
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function() {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.manuscriptForm.$error) {
                errorArray.push(error);
            }
            $scope.status.manuscriptFormError = $scope.status.manuscriptFormError == undefined ? [] : $scope.status.manuscriptFormError;
            if ($scope.status.manuscriptFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.manuscriptFormError = errorArray;
            }
            return $scope.status.manuscriptFormError; // 返回
        };

        /**
         * [initialSelector description] 时间选择器初始化
         * @return {[type]} [description]
         */
        $scope.initialSelector = function() {
            $scope.status.articleSelectorShow = false;
            $scope.status.leadSelectorShow = false;
            $scope.status.compileSelectorShow = false;
            $scope.status.totalSelectorShow = false;
        };

        /**
         * [save description] 保存稿件
         * @param  {[type]} type [description] 是否直接保存
         * @return {[type]}      [description]
         */
        $scope.save = function(type) {
            // 包含本地版本功能的稿件类型做了特殊处理，在进行其他操作时均先做此保存操作，以此来更新本地版本
            type = angular.isDefined(type) ? type : true;
            var defer = $q.defer();
            save(type).then(
                function() {
                    if ($scope.data.selectedReport) {
                        myManuscriptService.relatedReport({
                            ReportId: $scope.data.selectedReport.NEWREPORTID || 0, // 关联的报题id，删除关联波提关系是传0
                            MetaDataId: $stateParams.iwometadataid, // 稿件id
                            Title: $scope.list.TITLE, // 稿件名称
                            MediaType: -1, // 渠道类型参数
                        });
                    }
                    if ($scope.data.selectedTask) {
                        myManuscriptService.relatedTask({
                            TaskCommandId: $scope.data.selectedTask.TASKCOMMANDID || 0, // 关联的任务id，删除关联波提关系是传0
                            MetaDataId: $stateParams.iwometadataid || data.METADATAID, // 稿件id
                            Title: $scope.list.TITLE, // 稿件名称
                            MediaType: -1, // 渠道类型参数
                        });
                    }
                    if (!$scope.status.isFromPlannedOrder || type) {
                        editIsLock.lockDraft($stateParams.iwometadataid);
                        getVersion().then(function() {
                            defer.resolve();
                        });
                    }
                },
                function(msg) {
                    defer.reject(msg);
                }
            );
            return defer.promise;
        };

        /**
         * [getSuggestions description]获取suggestion
         * @param  {[str]} viewValue [description]输入框内输入值
         * @return {[type]}           [description]
         */
        $scope.getSuggestions = function(property, viewValue) {
            var searchUsers = {
                serviceid: 'mlf_extuser',
                methodname: 'queryUsersByName',
                IsSearchAll: false,
                Name: viewValue,
            };
            if (viewValue !== '' && !angular.isObject(viewValue)) {
                return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchUsers, 'post').then(function(data) {
                    if (data.length === 1 && data[0].USERNAME === $scope.data[property].USERNAME) {
                        data = [];
                    }
                    return data;
                });
            }
        };
        $scope.$watch('data.currReporter', function(newValue, oldValue, scope) {
            if (angular.isObject(newValue)) {
                if (getObjFromArr($scope.data.reporterArr, 'ID', newValue.ID) == -1) {
                    newValue.TYPE = '23';
                    $scope.data.reporterArr.push(newValue);
                }
                $scope.data.currReporter = '';
            }
        });
        $scope.$watch('data.currBroadcast', function(newValue, oldValue, scope) {
            if (angular.isObject(newValue)) {
                if (getObjFromArr($scope.data.broadcastArr, 'ID', newValue.ID) == -1) {
                    $scope.data.broadcastArr.push(newValue);
                }
                $scope.data.currBroadcast = '';
            }
        });
        $scope.$watch('data.currEditor', function(newValue, oldValue, scope) {
            if (angular.isObject(newValue)) {
                if (getObjFromArr($scope.data.compileArr, 'ID', newValue.ID) == -1) {
                    newValue.TYPE = '21';
                    $scope.data.compileArr.push(newValue);
                }
                $scope.data.currEditor = '';
            }
        });

        /**
         * [deleteItem description] 数组删除元素
         * @param  {[type]} arr  [description] 数组
         * @param  {[type]} item [description] 元素
         * @return {[type]}      [description]
         */
        $scope.deleteItem = function(arr, item) {
            arr.splice(arr.indexOf(item), 1);
        };

        /**
         * [addUser description] 添加用户
         * @param {[type]} arrProperty [description] 用户数组名
         */
        $scope.addUser = function(arrProperty) {
            $scope.editorJson = $scope.data[arrProperty];
            var modalInstance = $modal.open({
                templateUrl: './editingCenter/directive/app/views/editor_window_other_tpl.html',
                scope: $scope,
                windowClass: 'editor_window_class',
                backdrop: false,
                controller: 'editorOtherCtrl',
            });
            modalInstance.result.then(function(result) {
                for (var i = 0; i < result.length; i++) {
                    if (getObjFromArr($scope.data[arrProperty], 'ID', result[i].ID) == -1) {
                        result[i].TYPE = arrProperty === 'reporterArr' ? '23' : arrProperty === 'compileArr' ? '21' : '';
                        $scope.data[arrProperty].push(result[i]);
                    }
                }
            });
        };

        /**
         * [calculateAuto description] 时间自动计算
         * @return {[type]} [description]
         */
        $scope.calculateAuto = function() {
            var ue = UE.getEditor('ueditor');
            var content = ueditorService.getTextContent(ue.getContent());
            var leadContent = getText(content, '【导语】');
            var mainContent = getText(content, '【正文】');
            var compileContent = getText(content, '【编后】');
            var leadSeconds = leadContent.length * 60 > 0 ? (leadContent.length * 60) / $scope.data.speed : 0;
            var mainSeconds = mainContent.length * 60 > 0 ? (mainContent.length * 60) / $scope.data.speed : 0;
            var compileSeconds = compileContent.length * 60 > 0 ? (compileContent.length * 60) / $scope.data.speed : 0;
            $scope.list.CONTENTDURATION = timeTransform(mainSeconds);
            $scope.list.INTRODUCERDURATION = timeTransform(leadSeconds);
            $scope.list.EDITINGDURATION = timeTransform(compileSeconds);
            $scope.list.TOTALDURATION = timeTransform(mainSeconds + leadSeconds + compileSeconds);
        };

        /**
         * [iWoSubmit description] 提交
         * @return {[type]} [description]
         */
        $scope.iWoSubmit = function() {
            let methodname = ['PersonalSubmitDoc', 'ReceivedSubmitDoc', 'submit'];
          
            $scope.status.saveType = false; // 保存类型，为undefined或true时，代表保存时要加锁
            $scope.save(true).then(function () { // 提交放在保存后是因为提交内逻辑是需要实体稿件信息才能执行
                if ($state.params.departmentaldocid){ // 部门稿库需要加锁
                    editIsLock.lockDraft($state.params.iwometadataid);   
                }
                $scope.submitList = [{
                    CHNLDOCID: $state.params.iwochnldocid,
                    METADATAID: $state.params.iwometadataid,
                    DOCTYPEID: 9,
                }];
                newMediaService.iwoSubmit($scope, methodname[$state.params.iwoplatform]);
            });
        };
        // 多渠道提交触发结束
        /**
         * [saveSubmit description]多渠道提交函数
         *
         * @param   {[type]}  methodname  [methodname description]
         *
         * @return  {[type]}              [return description]
         */
        // function saveSubmit(methodname) {
        //     myManuscriptService.submit(
        //         $scope.data.incomeData,
        //         function() {
        //             storageListenerService.addListenerToIwo('manuscirptSubmit');
        //             var opened = $window.open('about:blank', '_self');
        //             opened.close();
        //         },
        //         function() {},
        //         methodname
        //     );
        // }
        // 传稿(个人稿库+已收稿库)
        $scope.iWoTransfer = function() {
            $scope.save(false).then(function() {
                editIsLock.normalLock($stateParams.iwometadataid);
                draft();
            });
        };

        /**
         * [closethenclose description]保存并关闭
         *
         * @return  {[type]}  [return description]
         */
        $scope.closethenclose = function() {
            editingCenterService.saveAndClose($scope.save);
        };

        // 传稿触发结束
        // 传稿函数
        /**
         * [draft description]传稿函数
         *
         * @return  {[type]}  [return description]
         */
        function draft() {
            var menthod = ['personalTransferMetaDatas', 'receivedTransferMetaDatas'];
            myManuscriptService.draft(
                '传稿',
                $scope.data.incomeData,
                function() {
                    storageListenerService.addListenerToIwo('manuscriptPassed');
                    var opened = $window.open('about:blank', '_self');
                    opened.close();
                },
                function() {},
                menthod[$stateParams.iwoplatform]
            );
        }
        // 传稿函数结束
        /**
         * [close description]页面关闭
         * @return {[type]} [description]
         */
        $scope.close = function() {
            var opened = $window.open('about:blank', '_self');
            opened.close();
        };

        /**
         * [toggleEditor description] 展开/收起全文
         * @return {[type]} [description]
         */
        $scope.toggleEditor = function() {
            $scope.status.zhengwen = !$scope.status.zhengwen;
            if ($scope.status.zhengwen) {
                // 隐藏编辑器
                $('.body_manuscript_content').addClass('editorHidden');
            } else {
                $('.body_manuscript_content').removeClass('editorHidden');
            }
        };

        /**
         * [timeTransform description] 时间格式转化
         * @param  {[type]} time [description] 时间（秒）
         * @return {[type]}      [description]
         */
        function timeTransform(time) {
            var hours = Math.floor(time / (60 * 60)) < 10 ? '0' + Math.floor(time / (60 * 60)) : Math.floor(time / (60 * 60));
            var minutes =
                Math.floor((time - hours * 60 * 60) / 60) < 10
                    ? '0' + Math.floor((time - hours * 60 * 60) / 60)
                    : Math.floor((time - hours * 60 * 60) / 60);
            var seconds =
                Math.round(time - hours * 60 * 60 - minutes * 60) < 10
                    ? '0' + Math.round(time - hours * 60 * 60 - minutes * 60)
                    : Math.round(time - hours * 60 * 60 - minutes * 60);
            return hours + ':' + minutes + ':' + seconds;
        }

        /**
         * [getAllIndex description] 获取指定字符串的全部下标
         * @param  {[type]} str    [description] 内容
         * @param  {[type]} subStr [description] 指定的字符串
         * @return {[type]}        [description] 下标数组
         */
        function getAllIndex(str, subStr) {
            var positions = new Array();
            var pos = str.indexOf(subStr);
            while (pos > -1) {
                // 每次搜索返回的位置被保存在数组positions中
                positions.push(pos);
                // 给indexOf()传递上一次的位置加1，确保了每次新搜索都从上一次找到的子字符串的后面开始
                pos = str.indexOf(subStr, pos + 1);
            }
            return positions;
        }

        /**
         * [getMin description] 获取数组最小值
         * @param  {[type]} arr      [description] 数组
         * @param  {[type]} minFloor [description] 最小值下限
         * @return {[type]}          [description]
         */
        function getMin(arr, minFloor) {
            var dealedArr = [];
            arr.forEach(function(item, index) {
                if (item > minFloor) {
                    dealedArr.push(item);
                }
            });
            if (dealedArr.length == 0) {
                return false;
            } else {
                var min = dealedArr[0];
                dealedArr.forEach(function(item) {
                    if (item < min) {
                        min = item;
                    }
                });
                return min;
            }
        }

        /**
         * [getText description] 全文本数据拼接
         * @param  {[type]} content  [description] 全文内容
         * @param  {[type]} strStart [description] 文本开始标识符
         * @return {[type]}          [description] 匹配的内容
         */
        function getText(content, strStart) {
            var indexArr = getAllIndex(content, strStart);
            var matchContent = '';
            for (var i = 0; i < indexArr.length; i++) {
                var leadNextIndex = content.indexOf('【导语】', indexArr[i] + 4);
                var mainNextIndex = content.indexOf('【正文】', indexArr[i] + 4);
                var compileNextIndex = content.indexOf('【编后】', indexArr[i] + 4);
                var nearNextIndex = getMin([leadNextIndex, mainNextIndex, compileNextIndex], -1);
                if (nearNextIndex != false) {
                    matchContent += content.substring(indexArr[i] + 4, nearNextIndex);
                } else {
                    matchContent += content.substring(indexArr[i] + 4);
                }
            }
            return matchContent.replace(/\\n/g, '').replace(/\s+/g, '');
        }
    },
]);
